import log from 'loglevel';

let testAuthAdminToken = "";
let testAuthBlogUserToken = "";
let testAuthUserToken = "";
const API_GATEWAY_STACK_ALPHA = "4mc9e4i1ug";
const API_GATEWAY_STACK_PROD = "1kfhj30r1f";
const _INTERNAL_TEST_ADMIN_TOKEN = "06579D8B-6591-490C-835B-EEC73719CA25";
const _INTERNAL_TEST_BLOG_USER_TOKEN = "14352A0B-AD43-4E79-A8DB-20A66227F73B";
const _INTERNAL_TEST_USER_TOKEN = "A7498453-FCBE-45AA-848D-B9C80EAFE024";
const CLOUDFRONT_ALPHA_ID = "d2vjx5khmawygf";
const CLOUDFRONT_PROD_ID = "d13s95w40fp4px";
// Test-mode Stripe material, shared by alpha and by every developer stage. Hoisted to a
// const because a developer stage must use the same test keys and must never be handed a
// live one.
const STRIPE_TEST_PUBLISHABLE_KEY = `pk_test_51P18YVJUOK2XBMgmPcOfazIstLWt7CR7E2w4nq3Q8jSNmisdqrK0FFTrWqOfivxATm6XLID9aCPBX6hzSjU78vrp00ngJfM0ql`;
const STRIPE_TEST_BILLING_URL = `https://billing.stripe.com/p/login/test_28o00n8hT4ptf72144`;
// Developer stages have no assets distribution or Kibana of their own; they share alpha's.
const ALPHA_ASSETS_DOMAIN_NAME = `assets.alpha.earningscalls.biz`;
const ALPHA_BASE_DOMAIN_NAME = `alpha.earningscall.biz`;
const API_PATH_PREFIX = `a2`;
// `/a3` is the expand-phase clone prefix from the per-domain API stack
// decomposition (cca infra/lib/api-routes.ts → DOMAIN_RULES). Only endpoints in
// the Earnings (`/a2/earnings*`, `/a2/transcript*`) and Internal (`/admin` in
// path) domains were cloned to `/a3`; the `/a2` originals stay live during
// expand→migrate→contract. The web app uses `/a3` ONLY for those cloned
// endpoints (see API_ENDPOINT_V3 / API_GATEWAY_ENDPOINT_V3 callers in api.mjs);
// every non-cloned endpoint keeps using `/a2`.
const API_PATH_PREFIX_V3 = `a3`;
let apiStageId = "";
let exchangesFile = "";
let symbolsFile = "";
let cloudFrontId = "";
let apiGatewayEndpoint = "";
let apiGatewayEndpointV3 = "";
let cloudFrontEndpoint = "";
let baseDomainName = "";
let kibanaEndpoint = "";
let dataFilesBucket = "";
let smallCalendarDaysBack;
let smallCalendarDaysForward;
let logRocketAppId;
let openReplayProjectKey;
let openReplayIngestPoint;
let openReplayDashboardUrl;
let maxCompanyApiConcurrency;
let stripePublishableKey;
let stripePublishableTestKey;
let stripeBillingUrl;
let clarityProjectId;
let assetsDomainName = "";

export const CFN_STAGE = process.env.GATSBY_CFN_STAGE || "alpha";
console.log("This is a console log statement");
log.debug("This is a debug statement");
log.debug("CFN_STAGE", CFN_STAGE);
export const IS_ALPHA_STAGE = CFN_STAGE === "alpha";
export const IS_PROD_STAGE = CFN_STAGE === "prod";
// A per-developer stage, deployed into that developer's own AWS account -- see
// documentation/30-developer-accounts.md in the cca repo. The stage name is the developer's
// stage name ("devtest2"), and it is also the subdomain. Anything that is neither alpha nor
// prod is one of these; there is no third kind.
export const IS_DEVELOPER_STAGE = !IS_ALPHA_STAGE && !IS_PROD_STAGE;
// A developer stage is ALPHA with a different domain and a different AWS account. It shares
// alpha's Elasticsearch cluster, media host, assets host and earningscall.dev endpoint, and
// it must never be built against live Stripe. So every value that is not genuinely
// per-account is decided by this rather than by IS_ALPHA_STAGE.
const IS_ALPHA_LIKE = IS_ALPHA_STAGE || IS_DEVELOPER_STAGE;
const USE_DEV_SYMBOLS = process.env.GATSBY_USE_DEV_SYMBOLS === "true";
const DEV_EXCHANGES_FILE_NAME = "dev-exchanges.json";
const DEV_SYMBOLS_FILE_NAME =  "dev-symbols.txt";
export const GITHUB_PULL_REQUEST_URL = process.env.GATSBY_GITHUB_PULL_REQUEST_URL;

log.debug("IS_ALPHA_STAGE", IS_ALPHA_STAGE);
log.debug("IS_PROD_STAGE", IS_PROD_STAGE);
log.debug("IS_ALPHA_STAGE", IS_ALPHA_STAGE);

/*
console.log("IN API CONFIG: Listing all environment variables...");
for (let [key, value] of Object.entries(process.env)) {
  console.log(` --> ${key}=${value}`);
}
console.log("DONE!");
*/

console.log(`\n\n-------> Stage = ${CFN_STAGE}`);
if (IS_ALPHA_STAGE) {
  apiStageId = API_GATEWAY_STACK_ALPHA;
  cloudFrontId = CLOUDFRONT_ALPHA_ID;
  baseDomainName = ALPHA_BASE_DOMAIN_NAME;
  assetsDomainName = ALPHA_ASSETS_DOMAIN_NAME;
  dataFilesBucket = `alpha-ecb-bucketsnestedst-datafilesbucket2dcb3fd1-1i1r8gq9opyqm`;
  stripePublishableKey = `pk_live_51P18YVJUOK2XBMgm0maekgS7JOswNTfAc1nQnzvVRjFQr02n7Jg7QVPtRSemWK3tP6oylLTZp8pIB27EfU5bDqQJ00N8qVfNXI`;
  stripePublishableTestKey = STRIPE_TEST_PUBLISHABLE_KEY;
  stripeBillingUrl = STRIPE_TEST_BILLING_URL;
} else if (IS_PROD_STAGE) {
  apiStageId = API_GATEWAY_STACK_PROD;
  cloudFrontId = CLOUDFRONT_PROD_ID;
  baseDomainName = `earningscall.biz`;
  assetsDomainName = `assets.earningscalls.biz`;
  dataFilesBucket = `prod-ecb-bucketsnestedsta-datafilesbucket2dcb3fd1-1fzfk71u0tjyu`;
  stripePublishableKey = `pk_live_51OxyR5DXWZwdbNFA3XBu3L0w3BeT96Dp23nHIWnmibgT6x7ozkwekJ4FGhuYd2jeVasoK3pJYTg45U16Wuo7N8Wc007JnWZBm8`;
  stripePublishableTestKey = ``;
  stripeBillingUrl = `https://billing.stripe.com/p/login/dR65mdcFE85o3n2bII`;
} else {
  // Developer stage. Only two things here are genuinely per-account -- the domain and the
  // data-files bucket. There is deliberately no apiStageId: the API Gateway is reached
  // same-origin instead (see below).
  //
  // GATSBY_BASE_DOMAIN is the escape hatch for a stage whose subdomain does not match its
  // stage name. Every account bootstrapped by cca's bin/bootstrap_dev_account.py gets
  // `<stage>.earningscall.biz`, so it is normally unset.
  baseDomainName = process.env.GATSBY_BASE_DOMAIN || `${CFN_STAGE}.earningscall.biz`;
  assetsDomainName = ALPHA_ASSETS_DOMAIN_NAME;
  // Deterministic, from physicalBucketName() in cca's infra/lib/buckets.ts. alpha and prod
  // are literals above only because their buckets predate that convention and still carry
  // CloudFormation-generated names.
  dataFilesBucket = `earningscall-data-files-${CFN_STAGE}`;
  // No live key is ever compiled into a developer build. STRIPE_TEST_MODE_ENABLED below is
  // true for these stages, so the test key is the one that gets used.
  stripePublishableKey = ``;
  stripePublishableTestKey = STRIPE_TEST_PUBLISHABLE_KEY;
  stripeBillingUrl = STRIPE_TEST_BILLING_URL;
}
cloudFrontEndpoint = `https://${baseDomainName}`;
// Kibana is a single shared deployment, not one per stage, so a developer stage links to
// alpha's rather than to a `kibana.<stage>.earningscall.biz` that does not exist.
kibanaEndpoint = `https://kibana.${IS_DEVELOPER_STAGE ? ALPHA_BASE_DOMAIN_NAME : baseDomainName}`;

if (IS_ALPHA_STAGE) {
  logRocketAppId = "vquhxv/cca-app";
  openReplayProjectKey = "GhXvKpZxx3Vu2BmBLcSf";
  openReplayIngestPoint = "https://replay.alpha.earningscall.biz/ingest";
  openReplayDashboardUrl = "https://replay.alpha.earningscall.biz";
  maxCompanyApiConcurrency = 1;
  // Added new clarity project for alpha testing 
  clarityProjectId = "x0pno05he5";
} else if (IS_PROD_STAGE) {
  logRocketAppId = "b5idae/earningscall";
  openReplayProjectKey = "GQnS2uRXzJpWSoWYlTRo";
  openReplayIngestPoint = "https://replay.earningscall.biz/ingest";
  openReplayDashboardUrl = "https://replay.earningscall.biz";
  maxCompanyApiConcurrency = 2;
  clarityProjectId = "w8vrrn3hlv";
} else {
  // Developer stage. Session-recording and analytics properties stay UNSET on purpose: they
  // are per-environment properties, and a dev build must not write sessions into alpha's.
  // Both OpenReplay entry points already no-op on a falsy project key
  // (OpenReplayLazyLoader.js:21, OpenReplayWrapper.js:44).
  //
  // Concurrency is not optional in the same way -- an undefined value would reach the
  // company-fetch limiter -- so it takes alpha's.
  maxCompanyApiConcurrency = 1;
}

const LOCAL_FILE_SERVER_ENDPOINT = "http://localhost:8000";

// Update this variable to true if you're on an airplane, and have no internet access.
// NOTE: You'll need a local file server, for example: $ python -m http.server 8000
export const LOCAL_ONLY_DEVELOPMENT = false;

if (LOCAL_ONLY_DEVELOPMENT) {
  apiGatewayEndpoint = `${LOCAL_FILE_SERVER_ENDPOINT}/${API_PATH_PREFIX}`;
  apiGatewayEndpointV3 = `${LOCAL_FILE_SERVER_ENDPOINT}/${API_PATH_PREFIX_V3}`;
} else if (IS_DEVELOPER_STAGE) {
  // Same-origin rather than the execute-api host. A developer account's API Gateway id is
  // not knowable to this repo -- it is generated per account -- and it does not need to be:
  // that account's CloudFront distribution carries the same `/a2/*` and `/a3/*` behaviours
  // as alpha's, pointed at its own API Gateway. Verified against devtest2's distribution.
  apiGatewayEndpoint = `${cloudFrontEndpoint}/${API_PATH_PREFIX}`;
  apiGatewayEndpointV3 = `${cloudFrontEndpoint}/${API_PATH_PREFIX_V3}`;
} else {
  apiGatewayEndpoint = `https://${apiStageId}.execute-api.us-east-1.amazonaws.com/${API_PATH_PREFIX}`;
  apiGatewayEndpointV3 = `https://${apiStageId}.execute-api.us-east-1.amazonaws.com/${API_PATH_PREFIX_V3}`;
}

if (process.env.GATSBY_MAX_COMPANY_API_CONCURRENCY) {
  maxCompanyApiConcurrency = parseInt(process.env.GATSBY_MAX_COMPANY_API_CONCURRENCY);
}

const nodeEnv = process.env.NODE_ENV;

if (nodeEnv === "development") {
  // Development mode (only executed in )
  smallCalendarDaysBack = 10;
  smallCalendarDaysForward = 10;
  exchangesFile = DEV_EXCHANGES_FILE_NAME;
  symbolsFile = DEV_SYMBOLS_FILE_NAME;
  testAuthAdminToken = _INTERNAL_TEST_ADMIN_TOKEN;
  testAuthBlogUserToken = _INTERNAL_TEST_BLOG_USER_TOKEN;
  testAuthUserToken = _INTERNAL_TEST_USER_TOKEN;
  const logLevel = "trace";
  console.log(`Setting log level to ${logLevel}.`);
  log.setLevel(logLevel);
} else {
  smallCalendarDaysBack = 5;
  smallCalendarDaysForward = 33;
  exchangesFile = "exchanges.json";
  symbolsFile = "symbols.txt";
  if (IS_ALPHA_LIKE) {
    log.setLevel("debug");
  } else if (IS_PROD_STAGE) {
    log.setLevel("info");
  }
}

if (USE_DEV_SYMBOLS) {
  exchangesFile = DEV_EXCHANGES_FILE_NAME;
  symbolsFile = DEV_SYMBOLS_FILE_NAME;
}

export const CLARITY_PROJECT_ID = clarityProjectId;
export const LOG_ROCKET_APP_ID = logRocketAppId;
export const OPEN_REPLAY_PROJECT_KEY = openReplayProjectKey;
export const OPEN_REPLAY_INGEST_POINT = openReplayIngestPoint;
export const OPEN_REPLAY_DASHBOARD_URL = openReplayDashboardUrl;
export const CODEBUILD_BUILD_NUMBER = process.env.GATSBY_CODEBUILD_BUILD_NUMBER || "dev";
export const CODEBUILD_RESOLVED_SOURCE_VERSION = process.env.GATSBY_CODEBUILD_RESOLVED_SOURCE_VERSION || "dev";
export const CODEBUILD_GIT_SHORT_ID = CODEBUILD_RESOLVED_SOURCE_VERSION.substring(0, 8);
export const BUILD_TIME = new Date().toISOString();
export const NODE_ENV = process.env.NODE_ENV;
export const TEST_AUTH_ADMIN_TOKEN = testAuthAdminToken; // Will be "" for non-development builds
export const TEST_AUTH_BLOG_USER_TOKEN = testAuthBlogUserToken; // Will be "" for non-development builds
export const TEST_AUTH_USER_TOKEN = testAuthUserToken; // Will be "" for non-development builds
export const API_GATEWAY_ENDPOINT = apiGatewayEndpoint;
// `/a3` execute-api host for the cloned Earnings/Internal endpoints only.
export const API_GATEWAY_ENDPOINT_V3 = apiGatewayEndpointV3;
export const CLOUD_FRONT_ABSOLUTE_ENDPOINT = LOCAL_ONLY_DEVELOPMENT ? LOCAL_FILE_SERVER_ENDPOINT : cloudFrontEndpoint;
export const KIBANA_ENDPOINT = kibanaEndpoint;
// Grafana. Unlike Kibana this is not per-stage and not even alpha-shared: there is one
// instance, reachable only at mon.earningscall.biz (no mon.<stage>.earningscall.biz record
// exists), so every stage links to the same host on purpose.
export const GRAFANA_ENDPOINT = "https://mon.earningscall.biz";
export const EXCHANGES_FILE = exchangesFile;
export const EXCHANGES_FILE_ABSOLUTE_PATH = `${CLOUD_FRONT_ABSOLUTE_ENDPOINT}/${EXCHANGES_FILE}`;
export const SYMBOLS_FILE = symbolsFile;
export const SYMBOLS_FILE_ABSOLUTE_PATH = `${CLOUD_FRONT_ABSOLUTE_ENDPOINT}/${SYMBOLS_FILE}`;
export const SITE_ROOT = LOCAL_ONLY_DEVELOPMENT ? "" : CLOUD_FRONT_ABSOLUTE_ENDPOINT;
export const API_ENDPOINT = `${SITE_ROOT}/${API_PATH_PREFIX}`;
// `/a3` CDN endpoint for the cloned Earnings/Internal endpoints only.
export const API_ENDPOINT_V3 = `${SITE_ROOT}/${API_PATH_PREFIX_V3}`;
// Inverted on IS_PROD_STAGE, not IS_ALPHA_STAGE: there is one non-prod earningscall.dev
// deployment, and a developer stage uses it rather than pointing at prod.
export const EARNINGS_CALL_DOT_DEV_ENDPOINT = IS_PROD_STAGE ? "https://prod.earningscall.dev" : "https://alpha.earningscall.dev";
// The Atlas fleet host the browser talks to. Atlas is the fleet; the reconciler is
// one of the things it serves, so this is not reconciler-specific.
//
// Not pinned to a region: `edge.earningscall.dev` is a Route 53 latency record set
// with a health check per box, so an unhealthy region drops out on its own rather
// than painting the whole fleet unreachable (atlas/dns/README.md). The `.biz` names
// CNAME onto it and are the only ones on the Atlas certs, so they are what a browser
// can reach. `x-region` on the response says which box answered.
const ATLAS_FLEET_HOST = IS_PROD_STAGE
  ? "edge.earningscall.biz"
  : "edge.alpha.earningscall.biz";
export const ATLAS_FLEET_ENDPOINT = `https://${ATLAS_FLEET_HOST}`;
export const LOG_ROCKET_PROXY_URL = `${SITE_ROOT}`;
export const STATIC_FILES_ENDPOINT = LOCAL_ONLY_DEVELOPMENT ? LOCAL_FILE_SERVER_ENDPOINT : SITE_ROOT;
export const AUDIO_FILE_ROOT = `${STATIC_FILES_ENDPOINT}/f`;
export const TRANSCRIPT_FILE_ROOT = `${STATIC_FILES_ENDPOINT}/t`;
export const DATA_FILES_BUCKET = dataFilesBucket;
export const SMALL_CALENDAR_DAYS_BACK = smallCalendarDaysBack;
export const SMALL_CALENDAR_DAYS_FORWARD = smallCalendarDaysForward;
export const MAX_COMPANY_API_CONCURRENCY = maxCompanyApiConcurrency;
export const STRIPE_ALPHA_TEST_MODE_ENABLED = true;
export const STRIPE_TEST_MODE_ENABLED = IS_ALPHA_LIKE ? STRIPE_ALPHA_TEST_MODE_ENABLED : false;
export const STRIPE_PUBLISHABLE_KEY = STRIPE_TEST_MODE_ENABLED ? stripePublishableTestKey : stripePublishableKey;
export const IS_DEVELOPMENT = process.env.GATSBY_IS_DEVELOP === "true";
// Master kill-switch for LogRocket. Set to `false` because we're no longer
// actively using LogRocket. The wrapper/loader code is intentionally left in
// place — flip this back to `true` to re-enable session recording everywhere.
export const ENABLE_LOG_ROCKET = false;
export const ENABLE_LOG_ROCKET_IN_DEVELOPMENT = false;
export const ENABLE_OPEN_REPLAY_IN_DEVELOPMENT = false;
export const WEB_SOCKET_URL = `wss://${baseDomainName}/websocket`;
// Call-page login gate (components/LoginGate.js): audio, transcript and slide deck
// ask an anonymous visitor to log in. This is the stage default -- the value the
// server-rendered HTML assumes and the value the PostHog flag `callPageLoginGate`
// falls back to when it has no opinion (flag absent, PostHog blocked). The PostHog
// flag is the runtime kill switch and ramp; `?callPageLoginGate=false` is the
// per-browser override. Flip a stage to `true` only once the gate is at 100% there:
// while it is `false` a visitor PostHog has bucketed into the gate sees the full
// content for the instant before the flag resolves, and while it is `true` the
// server HTML is gated for everyone and a logged-in visitor sees one clamped frame
// before hydration lifts it. Alpha is gated so the team lives with it; alpha is
// noindex, so no SEO exposure there.
export const CALL_PAGE_LOGIN_GATE_DEFAULT = IS_ALPHA_STAGE;
// Build only the transcript preview into the call pages -- HTML and page-data.json
// both -- and have a logged-in visitor fetch the rest from the API at runtime
// (src/transcriptPreview.mjs, getTranscriptFromApi in api.mjs). On for every stage:
// the full-text build is what a scraper was harvesting (cca-app#725), and there is
// no reason to keep shipping it anywhere. A BUILD-time switch, not a runtime flag:
// text the build left out cannot be put back by a flag, so the rollback is a
// rebuild with GATSBY_TRANSCRIPT_PREVIEW_ONLY=false (which also overrides the
// default for a local or one-off build). The TRANSCRIPT_FROM_API PostHog flag
// (components/Features.js) governs only such a full-text build: there it makes a
// logged-in visitor fetch from the API anyway, which is how the runtime half is
// exercised without giving the text back to the page.
export const TRANSCRIPT_PREVIEW_ONLY_DEFAULT = true;
export const TRANSCRIPT_PREVIEW_ONLY =
  process.env.GATSBY_TRANSCRIPT_PREVIEW_ONLY === undefined
    ? TRANSCRIPT_PREVIEW_ONLY_DEFAULT
    : process.env.GATSBY_TRANSCRIPT_PREVIEW_ONLY === "true";
// The Domain the backend's /a2/login Set-Cookie uses (cca/user.py writes
// `Domain=<CERTIFICATE_NAME>`). Browser.js mirrors the session id into the same
// cookie so cross-host requests to media.* authenticate -- see setSessionCookie.
export const SESSION_COOKIE_DOMAIN = baseDomainName;
// Support chat widget (components/support-chat) WebSocket endpoint. The widget
// is public and mounts on every page (containers/Layout.js). Overridable so it can be demoed
// against the local stub server (cca repo: python -m bin.support_chat_local):
//   GATSBY_SUPPORT_CHAT_WS_URL=ws://localhost:8765 gatsby develop
export const SUPPORT_CHAT_WS_URL = process.env.GATSBY_SUPPORT_CHAT_WS_URL || WEB_SOCKET_URL;
// The public developer API is a separate deployment (the EarningsCall/api repo, on Hetzner)
// with one non-prod instance, not one per stage. A developer stage documents alpha's host
// rather than a `v2.api.<stage>.earningscall.biz` that was never created. Only consumer is
// the API guide's sample curl commands (containers/apiGuideData/data.js).
export const PUBLIC_API_BASE_URL = `https://v2.api.${IS_DEVELOPER_STAGE ? ALPHA_BASE_DOMAIN_NAME : baseDomainName}`;
export const ASSETS_DOMAIN_NAME = assetsDomainName;
export const ASSETS_ROOT = `https://${assetsDomainName}`;
export const STRIPE_BILLING_URL = stripeBillingUrl;

log.debug("CODEBUILD_BUILD_NUMBER:", CODEBUILD_BUILD_NUMBER);
log.debug("CODEBUILD_GIT_SHORT_ID:", CODEBUILD_GIT_SHORT_ID);
log.debug("BUILD_TIME:", BUILD_TIME);
log.debug("NODE_ENV:", NODE_ENV);
log.debug("CFN_STAGE:", CFN_STAGE);
log.debug("NODE_ENV:", NODE_ENV);
log.debug("TEST_AUTH_ADMIN_TOKEN:", TEST_AUTH_ADMIN_TOKEN);
log.debug("TEST_AUTH_BLOG_USER_TOKEN:", TEST_AUTH_BLOG_USER_TOKEN);
log.debug("TEST_AUTH_USER_TOKEN:", TEST_AUTH_USER_TOKEN);
log.debug("AUDIO_FILE_ROOT:", AUDIO_FILE_ROOT);
log.debug("API_ENDPOINT:", API_ENDPOINT);
log.debug("API_ENDPOINT_V3:", API_ENDPOINT_V3);
log.debug("API_GATEWAY_ENDPOINT:", API_GATEWAY_ENDPOINT);
log.debug("API_GATEWAY_ENDPOINT_V3:", API_GATEWAY_ENDPOINT_V3);
log.debug("SYMBOLS_FILE:", SYMBOLS_FILE);
log.debug("SYMBOLS_FILE_ABSOLUTE_PATH:", SYMBOLS_FILE_ABSOLUTE_PATH);
log.debug("CLOUD_FRONT_ABSOLUTE_ENDPOINT:", CLOUD_FRONT_ABSOLUTE_ENDPOINT);
log.debug("KIBANA_ENDPOINT:", KIBANA_ENDPOINT);
log.debug("MAX_API_CONCURRENCY:", MAX_COMPANY_API_CONCURRENCY);
log.debug("STRIPE_TEST_MODE_ENABLED:", STRIPE_TEST_MODE_ENABLED);
log.debug("STRIPE_PUBLISHABLE_KEY:", STRIPE_PUBLISHABLE_KEY);


export function audioFileUrl(fileName) {
  return `${AUDIO_FILE_ROOT}/${fileName}`;
}

export function transcriptFileUrl(fileName) {
  return `${TRANSCRIPT_FILE_ROOT}/${fileName}`;
}

// Stage-aware host for the new media-streaming endpoint served by the api
// cluster. Local dev uses the alpha host directly — same URL the alpha
// build emits — so there's nothing local-only to keep in sync.
export function computeMediaHost({ isProdStage }) {
  if (isProdStage) return "https://media.earningscall.biz";
  return "https://media.alpha.earningscall.biz";
}
export const MEDIA_HOST = computeMediaHost({ isProdStage: IS_PROD_STAGE });

function streamParams({ exchange, symbol, year, quarter }) {
  return new URLSearchParams({
    exchange: String(exchange).toLowerCase(),
    symbol: String(symbol).toLowerCase(),
    year: String(year),
    quarter: String(quarter).toLowerCase(),
  });
}

// Optional `devSessionToken` arg appends `?token=<value>` to the URL. The
// caller (Player in CallComponents.js) only passes it in NODE_ENV=development,
// where the cross-site cookie can't ride from localhost and we need an
// alternative auth path the bare <audio> element can carry. In production
// builds the branch is dead-code-eliminated by webpack — the session token
// never enters the prod bundle.
function appendDevToken(params, devSessionToken) {
  if (devSessionToken) {
    params.append("token", devSessionToken);
  }
  return params;
}

export function audioStreamUrl(
  { exchange, symbol, year, quarter },
  { devSessionToken } = {}
) {
  const params = appendDevToken(
    streamParams({ exchange, symbol, year, quarter }),
    devSessionToken
  );
  return `${MEDIA_HOST}/audio?${params}`;
}

export function transcriptStreamUrl(
  { exchange, symbol, year, quarter },
  { devSessionToken } = {}
) {
  const params = appendDevToken(
    streamParams({ exchange, symbol, year, quarter }),
    devSessionToken
  );
  return `${MEDIA_HOST}/transcript?${params}`;
}

// Same-origin proxy path. CloudFront routes /media/* on earningscall.biz to
// the media cluster (the /media prefix is stripped at the edge — see cca PR
// #398). Returned as a relative URL so the browser resolves it against the
// current page origin; that's what lets <a download> actually trigger a
// download (the attribute is silently ignored for cross-origin URLs, which
// rules out the media.* host emitted by audioStreamUrl).
//
// No devSessionToken parameter: on localhost the proxy doesn't exist, so
// this URL just 404s in dev when STREAM_AUDIO is on. Acceptable — dev
// downloads aren't part of the supported path.
export function audioDownloadUrl({ exchange, symbol, year, quarter }) {
  const params = streamParams({ exchange, symbol, year, quarter });
  return `/media/audio?${params}`;
}
